/*
 * Public API Surface of ng2-panzoom
 */

export * from './lib/ng2-panzoom.module';
export * from './lib/panzoom.component';
export * from './lib/panzoom-api';
export * from './lib/panzoom-model';
export * from './lib/panzoom-config';
